import React, { useMemo, useEffect, useState } from "react";
import Select from "react-select";
import { getMdas } from "common/services/mda.service";
import { normalize } from "common/lib/normalize";

type FilterProps = {
  onChange: (value: any) => void;
  value: any;
  regionId?: string;
};
const MDAFilter = ({ onChange, value, regionId }: FilterProps) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#ced4da",
      },
    }),
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let filters: any = {};
        if (regionId) {
          filters = {
            region: regionId,
          };
        }
        const response = await getMdas({
          pagination: {
            page: 1,
            pageSize: 500,
          },
          filters,
          fields: ["id", "name"],
          populate: ["region"],
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [regionId, setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name} - ${el?.region?.name}`,
      };
    });
  }, [data]);

  return (
    <Select
      name="mda"
      id="mda"
      isSearchable
      isClearable
      placeholder="Select MDA"
      onChange={onChange}
      options={options}
      value={value}
      styles={customSelectStyles}
      loading={loading}
    />
  );
};

export default MDAFilter;
